/**
 * @Author: abbeymart | Abi Akindele | @Created: 2019-08-17 | @Updated: 2019-08-17
 * @Company: mConnect.biz | @License: MIT
 * @Description: mc-central: locale routes map
 */

import type { RouteRecordRaw } from 'vue-router';

export const localeRoutes: Array<RouteRecordRaw> = [
  {
    path: '/locale',
    name: 'locale',
    redirect: '/locale/list',
    component: () => import('pages/central/locale/McLocale.vue'),
    meta: {
      title: 'Locales - Internationalization',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'localeList',
        component: () => import('pages/central/locale/LocaleList.vue'),
        meta: {
          title: 'Locales List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'localeDetail',
        component: () => import('pages/central/locale/LocaleDetail.vue'),
        meta: {
          title: 'Locale Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'localeNew',
        component: () => import('pages/central/locale/LocaleNew.vue'),
        meta: {
          title: 'New Locale',
          requiresAuth: true,
        },
      },
    ],
  },
];
